import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

export type PiRequirementTone = 'success' | 'warning';

/**
 * Ítem de requisito (punto + título + descripción).
 * Success: punto verde; warning: punto naranja.
 */
@Component({
  selector: 'app-pi-requirement-item',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="pi-requirement-item" [attr.data-tone]="tone">
      <span class="pi-requirement-item__dot" aria-hidden="true"></span>
      <div class="pi-requirement-item__content">
        <p class="pi-requirement-item__title">{{ title }}</p>
        <div class="pi-requirement-item__description">
          <ng-content></ng-content>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }

      .pi-requirement-item {
        display: flex;
        flex-direction: row;
        align-items: flex-start;
        gap: 8px;
        width: 100%;
      }

      .pi-requirement-item__dot {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        justify-content: center;
        width: 26px;
        height: 26px;
        padding: 4px 0;
        box-sizing: border-box;
      }

      .pi-requirement-item__dot::before {
        content: '';
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background: #9ed371;
      }

      .pi-requirement-item[data-tone='warning'] .pi-requirement-item__dot::before {
        background: #ffc27c;
      }

      .pi-requirement-item__content {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 4px;
        min-width: 0;
        flex: 1;
      }

      /* Body/L/SemiBold */
      .pi-requirement-item__title {
        margin: 0;
        font-family: var(--ds-foundation-font-family-primary, 'Sura Sans', sans-serif);
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 25px;
        color: #000000;
      }

      /* Body/Regular */
      .pi-requirement-item__description {
        margin: 0;
        width: 100%;
        font-family: var(--ds-foundation-font-family-primary, 'Sura Sans', sans-serif);
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 22px;
        color: #545b6a;
      }

      .pi-requirement-item__description ::ng-deep ul {
        margin: 0;
        padding-left: 18px;
        list-style: disc;
      }

      .pi-requirement-item__description ::ng-deep li {
        margin: 0;
      }
    `,
  ],
})
export class PiRequirementItemComponent {
  @Input() title = '';
  @Input() tone: PiRequirementTone = 'success';
}
